import React from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import { useVariantCategoriesByAdmin} from '../../../hooks/admin/variantCategory.admin';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import EmptyData from '../../../components/ui/EmptyData';
import VariantCategoriesListTable from '../../../components/admin/variantCategories/VariantCategoryListTable';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function AdminViewVariantCategoriesPage() {
  const {t} = useTranslation();
  const {data:variants, isError,isLoading} = useVariantCategoriesByAdmin();
  console.log(variants)
  return (
    <Layout title={t("admin_sidebar.variant_categories")} headline=''>
        <div className='flex justify-end'>
            <PermissionGate permissions={[PermissionsKey.CreateVariantCategory]}>
              <PrimaryButtonWithIconAdd
              buttonLabel="add_new_variant_category"
              buttonLinkPath={`/admin/add-variantCategory`}
              />
            </PermissionGate>
        </div>
      <LoadingErrorState
      isError={isError}
      isLoading={isLoading}
      />
       {
        variants && (
          variants.length === 0 ?<EmptyData/> : <VariantCategoriesListTable variants={variants}/>
        )
        }
    </Layout>
  )
}

export default AdminViewVariantCategoriesPage